import { render, staticRenderFns } from "./ConfirmacionEliminar.vue?vue&type=template&id=3ceead88&scoped=true"
import script from "./ConfirmacionEliminar.vue?vue&type=script&lang=js"
export * from "./ConfirmacionEliminar.vue?vue&type=script&lang=js"
import style0 from "./ConfirmacionEliminar.vue?vue&type=style&index=0&id=3ceead88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ceead88",
  null
  
)

export default component.exports